import { useEffect, useState } from "react";
import api from "../api/client";
export function useAzureResources() {
  const [resources, setResources] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let mounted = true;
    api.get("/api/resources/terraform")
      .then(r => mounted && setResources(r.data?.resources || []))
      .catch(e => mounted && setError(e.message))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);
  return { resources, loading, error };
}
